import { render, staticRenderFns } from "./AdvertisingBlock.vue?vue&type=template&id=d2ab355a&scoped=true&"
import script from "./AdvertisingBlock.vue?vue&type=script&lang=js&"
export * from "./AdvertisingBlock.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingBlock.vue?vue&type=style&index=0&id=d2ab355a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ab355a",
  null
  
)

export default component.exports